import { Button, Spin, Divider } from "antd";
import { React, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { put_api } from "api";
import { toast } from "react-toastify";
import useCompanyProfileHook from "./useCompanyProfileHook";
import { Card, CardBody, Col, Form, FormGroup, Input, Row } from "reactstrap";
import dayjs from "dayjs";

const CompanyProfile = () => {
    const { isLoading, companyProfileData } = useCompanyProfileHook();
    const params = useParams();
    const navigate = useNavigate();
    
    const [ loading, setLoading ] = useState(false);
    const [ profile, updateProfile ] = useState( companyProfileData );
    
    if( false === profile && !isLoading && false !== companyProfileData ){
        updateProfile( companyProfileData );
    }
    
    const handleSave = async () => {
        try {
            setLoading(true);
            const updateProfile = await put_api( "company-profile/"+params.id, profile );
            if( 200 !== updateProfile.status ){
                const errorMsg = updateProfile.message ?? "Failed to update company profile.";
                console.log("🚀 ~ handleSave ~ err:", updateProfile);
                toast.error(errorMsg);
            }
            console.log("🚀 ~ handleSave ~ response:", updateProfile);
            toast.success("Saved!");
            setLoading(false);
            navigate("/business-users");
        } catch (err) {
            console.log("🚀 ~ handleSave ~ err:", err);
            toast.error(err.message);
            setLoading(false);
        }
    };
    
    console.log('profile state: ', profile, companyProfileData);
    return (
        <div className="content mb-0">
            {isLoading ? (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                    }}
                >
                    <Spin size="large" />
                </div>
            ) : (
                <Row>
                    <Col md="12">
                        <Card className="card-user">
                            <CardBody>
                                <Form>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Company</label>
                                                <Input
                                                    className="input-value"
                                                    value={profile?.companyName}
                                                    placeholder="Company"
                                                    type="text"
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            companyName:newVal
                                                        } );
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Email address</label>
                                                <Input
                                                    className="input-value"
                                                    placeholder="Email"
                                                    type="email"
                                                    value={profile?.contact?.email}
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            contact: {
                                                                ...profile?.contact,
                                                                email: newVal
                                                            }
                                                        } );
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Website</label>
                                                <Input
                                                    className="input-value"
                                                    value={profile?.contact?.website}
                                                    placeholder="Website"
                                                    type="text"
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            contact: {
                                                                ...profile?.contact,
                                                                website: newVal
                                                            }
                                                        } );
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Phone</label>
                                                <Input
                                                    className="input-value"
                                                    placeholder="Phone"
                                                    value={profile?.contact?.phone}
                                                    type="text"
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            contact: {
                                                                ...profile?.contact,
                                                                phone: newVal
                                                            }
                                                        } );
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Testing Time</label>
                                                <Input
                                                    className="input-value"
                                                    placeholder="Testing Time"
                                                    value={profile?.testingTime}
                                                    type="select"
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            testingTime: newVal
                                                        } );
                                                    }}
                                                >
                                                    <option value={"20-mins"}>20 Mins</option>
                                                    <option value={"30-mins"}>30 Mins</option>
                                                    <option value={"60-mins"}>1 Hour</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Vaccinated: </label>
                                                <Input
                                                    className="input-value"
                                                    placeholder="Testing Time"
                                                    value={profile?.isVaccinated??false}
                                                    type="select"
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            isVaccinated: newVal
                                                        } );
                                                    }}
                                                >
                                                    <option value={true}>Yes</option>
                                                    <option value={false}>No</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Default Latitude: </label>
                                                <Input
                                                    className="input-value"
                                                    placeholder="Latitude"
                                                    value={profile?.location?.lat}
                                                    type="text"
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            location: {
                                                                ...profile?.location,
                                                                lat: newVal
                                                            }
                                                        } );
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Default Longitude: </label>
                                                <Input
                                                    className="input-value"
                                                    placeholder="Longitude"
                                                    value={profile?.location?.long}
                                                    type="text"
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            location: {
                                                                ...profile?.location,
                                                                long: newVal
                                                            }
                                                        } );
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Approved? </label>
                                                <Input
                                                    className="input-value"
                                                    placeholder="Testing Time"
                                                    value={profile?.isVerified??false}
                                                    type="select"
                                                    onChange={e=>{
                                                        const newVal = e.target.value;
                                                        updateProfile( {
                                                            ...profile,
                                                            isVerified: newVal
                                                        } );
                                                    }}
                                                >
                                                    <option value={true}>Yes</option>
                                                    <option value={false}>No</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Services</label>
                                                {profile?.services?.map((srvs, idx) => {
                                                    return (
                                                        <p className="text-capitalize mb-0">
                                                            {idx + 1}. {srvs.name}
                                                        </p>
                                                    );
                                                })}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Softwares</label>
                                                {profile?.software?.map((sftwr, idx) => {
                                                    return (
                                                        <p className="text-capitalize mb-0">
                                                            {idx + 1}. {sftwr.name}
                                                        </p>
                                                    );
                                                })}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">Equipments</label>
                                                {profile?.equipment?.map((eqpmnt, idx) => {
                                                    return (
                                                        <p className="text-capitalize mb-0">
                                                            {idx + 1}. {eqpmnt.name}
                                                        </p>
                                                    );
                                                })}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">
                                                    Additional Requirements
                                                </label>
                                                {profile?.additionalRequirements?.map(
                                                    (adReq, idx) => {
                                                        return (
                                                            <p className="text-capitalize mb-0">
                                                                {idx + 1}. {adReq}
                                                            </p>
                                                        );
                                                    }
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">
                                                    Primary Language
                                                </label>
                                                <p className="text-capitalize mb-0">
                                                    {(profile && profile?.language?.length > 0) ? profile?.language?.[0].language : ""}
                                                </p>
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="card-sub-title">
                                                    Secondary Language
                                                </label>
                                                {profile?.language
                                                    ?.splice(1)
                                                    ?.map((sec, idx) => {
                                                        return (
                                                            <p className="text-capitalize mb-0">
                                                                {idx + 1}. {sec?.language}
                                                            </p>
                                                        );
                                                    })}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Divider />
                                    {companyProfileData?.pricingPlan && (
                                        <div className="card-sec">
                                            <h4 className="card-sec-title">Pricing Details</h4>
                                            <Row>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">
                                                            Subscription Type:{" "}
                                                        </label>
                                                        <p className="text-capitalize mb-0">
                                                            {companyProfileData?.pricingPlan
                                                                ?.productIntervalType === "month"
                                                                ? "Monthly"
                                                                : "Yearly"}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">Amount: </label>
                                                        <p className="text-capitalize mb-0">
                                                            ${companyProfileData?.pricingPlan?.totalPaid}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">
                                                            Subscription Status:{" "}
                                                        </label>
                                                        <p className="text-capitalize mb-0">
                                                            {companyProfileData?.pricingPlan?.cancelAt
                                                                ? "Cancelled"
                                                                : companyProfileData?.pricingPlan
                                                                    ?.subscriptionStatus}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">
                                                            Subscription Id:{" "}
                                                        </label>
                                                        <p className="text-capitalize mb-0">
                                                            {companyProfileData?.pricingPlan?.subscriptionId}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">
                                                            Trial Start:{" "}
                                                        </label>
                                                        <p className="text-capitalize mb-0">
                                                            {dayjs
                                                                .unix(
                                                                    companyProfileData?.pricingPlan
                                                                        ?.trialPeriodStartDate
                                                                )
                                                                .format("DD-MM-YYYY")}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">
                                                            Trial End:{" "}
                                                        </label>
                                                        <p className="text-capitalize mb-0">
                                                            {dayjs
                                                                .unix(
                                                                    companyProfileData?.pricingPlan
                                                                        ?.trialPeriodEndDate
                                                                )
                                                                .format("DD-MM-YYYY")}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">
                                                            Invoice Status:{" "}
                                                        </label>
                                                        <p className="text-capitalize mb-0">
                                                            {companyProfileData?.pricingPlan?.invoiceStatus}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">
                                                            Discount Coupon:{" "}
                                                        </label>
                                                        <p className="text-capitalize mb-0">
                                                            {companyProfileData?.pricingPlan?.couponName ? companyProfileData?.pricingPlan?.couponName : "-"}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="card-sub-title">
                                                            Discount Coupon Id:{" "}
                                                        </label>
                                                        <p className="text-capitalize mb-0">
                                                            {companyProfileData?.pricingPlan?.couponCodeId ? companyProfileData?.pricingPlan?.couponCodeId : "-"}
                                                        </p>
                                                    </FormGroup>
                                                </Col>
                                                {/* <Col md="3">
                                                <label className="card-sub-title">Subscription Id: </label>
                                                <p className="text-capitalize mb-0">
                                                    {companyProfileData?.pricingPlan?.subscriptionId}
                                                </p>
                                            </Col> */}
                                            </Row>
                                        </div>
                                    )}
                                    <div className="footer-btn-wrap">
                                        <Button
                                            className="common-footer-btn cancel-btn-wrap"
                                            onClick={() => navigate("/business-users")}
                                        >
                                            Back
                                        </Button>
                                        <Button
                                            className="common-footer-btn save-btn-wrap"
                                            onClick={handleSave}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                    {loading && <Spin size="large" fullscreen />}
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default CompanyProfile;
